export const translationKeys = {
  home: 'breadcrumb.home',
  brand: 'breadcrumb.brand',
  dashboard: 'breadcrumb.dashboard',
  'dashboard-panel': 'breadcrumb.home',
  users: 'breadcrumb.users',
  channels: 'breadcrumb.myChannels',
  mychannels: 'breadcrumb.myChannels',
  'my-channels': 'breadcrumb.myChannels',
  accounts: 'breadcrumb.accounts',
  profile: 'breadcrumb.profile',
  detail: 'breadcrumb.detail',
  cms: 'breadcrumb.cms',
  organization: 'breadcrumb.organization',
  contents: 'breadcrumb.contents',
  videos: 'breadcrumb.videos',
  playlists: 'breadcrumb.playlists',
  settings: 'breadcrumb.settings',
  channelSettings: 'breadcrumb.channelSettings',
  installationDefaults: 'breadcrumb.installationDefaults',
  cmsChannels: 'breadcrumb.cmsChannels',
  cmsPolicies: 'breadcrumb.cmsPolicies',
  cmsSettings: 'breadcrumb.cmsSettings',
  'role-management': 'breadcrumb.roleManagement',
  /*-Reports-*/
  reports: 'breadcrumb.reports',
  'user-reports': 'breadcrumb.userReports',
  companyReports: 'breadcrumb.companyReports',
  /*-Parameterts-*/
  dynamicParameter: 'breadcrumb.dynamicParameter',
  productParameter: 'breadcrumb.productParameter',
  companyParameter: 'breadcrumb.companyParameter',
  licansorParameter: 'breadcrumb.licansorParameter',
  producerParameter: 'breadcrumb.producerParameter',
  'profile-information': 'breadcrumb.profileInformation',
  'portal-reports': 'breadcrumb.portalReports',
  'notification-preferences': 'breadcrumb.notificationPreferences',
  'my-works': 'breadcrumb.myWorks',
  'performance-reporting': 'breadcrumb.performanceReporting',
};
